import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
  sort: 'top',
  status: '',
  featureStatus: '',
  mine: false,
  voted: false,
};

const suggestionsSlice = createSlice({
  name: 'suggestionsUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
      state.page = 1;
    },
    // Cambiar orden o filtros siempre regresa a la primera página
    setSort: (state, action) => {
      state.sort = action.payload;
      state.page = 1;
    },
    setFilters: (state, action) => {
      Object.assign(state, action.payload);
      state.page = 1;
    },
    resetSuggestionsFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, setSort, setFilters, resetSuggestionsFilters } = suggestionsSlice.actions;
export default suggestionsSlice.reducer;
